import axios from "axios";

export const apiReportClient = axios.create({
  baseURL: `https://playground.jsreport.net/w/anon/Rqn8vbHC/api/report`,
  responseType:'blob'
})